'use strict';

module.exports = {
    data: {}
};
